import React from 'react'
import { CardActions, IconButton, Tooltip, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { withTranslation } from 'react-i18next'
import DeleteDialog from '../../DeleteDialog'
import 'react-block-ui/style.css'
import { authContext } from '../../../contexts/AuthContext'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { Link } from 'react-router-dom'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPSettingsIconButton from '../../Utils/CPSettingsIconButton'
import OpenInBrowserOutlinedIcon from '@mui/icons-material/OpenInBrowserOutlined'
import { apiUrl } from '../../../config/api'

class SocietyCard extends React.Component {
  constructor() {
    super()
    this.state = {
      deleteSociety: {}
    }
  }

  static contextType = authContext

  handleDeleteSocietyOpen = (society) => {
    this.setState({ deleteSociety: society })
  }

  handleDialogClose = () => {
    this.setState({ deleteSociety: {} })
  }

  deleteSociety = (society) => {
    society.updated_by = this.context.auth.user.id
    society.brandLabel = window.$brand

    let url = apiUrl('DeleteSociety')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(society)
    })
      .then((res) => console.log(res))
      .then(() => console.log('Delete successful'))
      .catch((error) => console.log(error))

    this.props.cardDeleteHandler(society)
  }

  formatDate = (dateStr) => {
    if (!dateStr) return '-'
    const [year, month, day] = dateStr.split('T')[0].split('-')
    return `${day}/${month}/${year}` // o yyyy/MM/dd si preferís
  }

  render() {
    const { t } = this.props
    const society = this.props.society
    const languageMap = {
      es: t('Spanish'),
      en: t('English')
    }

    const statusMap = {
      active: t('Active'),
      inactive: t('Inactive')
    }

    const typeMap = {
      'S.A': t('SA'),
      'S.R.L': t('SRL')
    }

    return (
      <Card
        sx={{
          minWidth: 275,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: window.$brand === 'BLP' ? 5 : 0,
          mr: window.$brand === 'BLP' ? 10 : 0
        }}
      >
        <CardContent sx={{ paddingBottom: 0 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography color='text.primary' variant='body1'>
                <strong>{society.legal_id}</strong> (
                {statusMap[society.current_status] || society.current_status})
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='body2' color='text.secondary'>
                {t('Type')}: {typeMap[society.type] || society.type}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {t('Constitution Date')}:{' '}
                {this.formatDate(society.constitution_date)}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {t('Corporate Address')}: {society.address || '-'}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                {t('Language')}:{' '}
                {languageMap[society.language] || society.language}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>

        <CardActions style={{ marginTop: 'auto' }}>
          <Link
            to={{
              pathname: `/society/${society.id}`,
              state: { society }
            }}
          >
            <IconButton sx={{ color: '#78BE20' }} edge='end'>
              <Tooltip title={t('Open')}>
                <OpenInBrowserOutlinedIcon />
              </Tooltip>
            </IconButton>
          </Link>

          {(this.context.auth.user.userType?.startsWith('admin') ||
            window.$brand === 'PRB' ||
            window.$brand === 'BLP') && (
            <>
              {this.context.auth.type !== 'client' && (
                <>
                  <Link
                    to={{
                      pathname: '/AdministracionSociety',
                      state: { society }
                    }}
                  >
                    <CPSettingsIconButton />
                  </Link>
                  <CPDeleteIconButton
                    onClick={() => this.handleDeleteSocietyOpen(society)}
                  />
                </>
              )}
            </>
          )}
        </CardActions>

        <DeleteDialog
          item={this.state.deleteSociety}
          title={t('delete_society')}
          caption={t('delete_society_full_caption')}
          targetFunc={this.deleteSociety}
          handleDialogClose={this.handleDialogClose}
        />
      </Card>
    )
  }
}

export default withTranslation()(SocietyCard)
